import { GifDecision, GifDecisionQuery } from '@dreryk/egabinet-dashboard-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';

type UseGifDecisions = {
   gifDecisions: GifDecision[] | undefined;
   gifDecisionsLoading: boolean;
   gifDecisionsError: Error | null;
};

const NUMBER_OF_GIF_DECISIONS_ON_PAGE = 6;

export const useGifDecisions = (): UseGifDecisions => {
   const { data: gifDecisions, loading: gifDecisionsLoading, error: gifDecisionsError } = useCqrsSearch<GifDecision>(
      () => {
         return new GifDecisionQuery();
      },
      paginations.part(0, NUMBER_OF_GIF_DECISIONS_ON_PAGE),
      {
         cacheTime: 'short',
      }
   );
   return {
      gifDecisions: gifDecisions,
      gifDecisionsError: gifDecisionsError,
      gifDecisionsLoading: gifDecisionsLoading,
   };
};
